/** Ported verbatim from clario-frontend src/utils/theme/sidebarPresets.ts. */

export type SidebarPreset = {
  id: string;
  name: string;
  railColor: string;
};

export const SIDEBAR_PRESETS: SidebarPreset[] = [
  { id: 'default', name: 'Default', railColor: '#FFFFFF' },
  { id: 'slate', name: 'Slate', railColor: '#1E293B' },
  { id: 'midnight', name: 'Midnight', railColor: '#0F172A' },
  { id: 'indigo', name: 'Indigo', railColor: '#312E81' },
  { id: 'violet', name: 'Violet', railColor: '#2E1065' },
  { id: 'emerald', name: 'Emerald', railColor: '#064E3B' },
  { id: 'ocean', name: 'Ocean', railColor: '#0C4A6E' },
  { id: 'rose', name: 'Rose', railColor: '#881337' },
  { id: 'amber', name: 'Amber', railColor: '#78350F' },
  { id: 'zinc', name: 'Zinc', railColor: '#27272A' },
];
